export const getTimestampDiffInMinutes = (timestamp1: number, timestamp2: number) => {
  return (timestamp1 - timestamp2) / 60e3;
};
